import React from "react";
import awsconfig from "./config/aws-exports";
import Amplify, { Auth } from "aws-amplify";
import AppWithData from "./containers/AppWithData.js";
import { InitData } from "./config/InitData";

Amplify.configure({
  ...awsconfig,
  region: "us-east-1",
  Analytics: {
    disabled: true,
  },
});

class App extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    // console.log(`Node enviroment: ${JSON.stringify(process.env)}`);
    Auth.currentAuthenticatedUser().then((user) => {
      // initial jwt retrieval
      const authorization =
        "Bearer " + user.signInUserSession.accessToken.jwtToken;
      InitData.getInstance().setAuthorization(authorization);
    });
    InitData.getInstance().setApiKey(process.env.REACT_APP_APIGEE_APIKEY);
    InitData.getInstance().setApiPrefix(process.env.REACT_APP_APIGEE_URLPRE);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.authState !== this.props.authState) {
      Auth.currentAuthenticatedUser().then((user) => {
        // initial jwt retrieval
        const authorization =
          "Bearer " + user.signInUserSession.accessToken.jwtToken;
        InitData.getInstance().setAuthorization(authorization);
      });
    }
  }

  handleLogOut = () => {
    Auth.signOut();
  };

  render() {
    console.log("auth state is " + this.props.authState);
    if (
      this.props.authState === "signedIn" ||
      this.props.authState === "verifyContact"
    ) {
      return <AppWithData handleLogOut={this.handleLogOut} />;
    } else {
      return null;
    }
  }
}

export default App;
